/**
 * Takes care of removing the loading screen if it's still visible.
 * The loading screen HTML is added to our index.html entry point today to ensure it shows immediately,
 * even before Vue is bootstrapping.
 *
 * Ensure this function is called at least once during app load.
 */

export function handleLoadingScreenRemoval() {
  const loadingStyles = document.getElementById('loadingStyles');
  const loadingElement = document.getElementById('loadingElement');
  if (loadingStyles?.parentElement) {
    loadingStyles.parentElement.removeChild(loadingStyles);
  }
  if (loadingElement?.parentElement) {
    loadingElement.parentElement.removeChild(loadingElement);
  }
}
